import { useEffect, useState } from "react";
import { TextInput } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

import ExpandedLayout from "./ExpandedLayout";
import MaxWidth from "./MaxWidth";
import { FormLayout } from "hooks/FormDesigner/useElementList";

type Props = {
	formLabel: string;
	formValidation: boolean;
	formLayout: FormLayout;
	updateFormLabel: (data: string) => void;
	updateFormLayoutFullWidth: (data: boolean) => void;
	updateFormLayoutMaxWidth: (data: number | null) => void;
};

export default function FormDetails({
	formLabel,
	formValidation,
	formLayout,
	updateFormLabel,
	updateFormLayoutFullWidth,
	updateFormLayoutMaxWidth,
}: Props) {
	const [formLabelValue, setFormLabelValue] = useState(formLabel);

	const { t } = useTranslation();

	useEffect(() => {
		setFormLabelValue(formLabel);
	}, [formLabel]);

	return (
		<div className="form-group form-details">
			<div className="row">
				<div className="col">
					<TextInput
						id="form-label"
						label={t("formDesigner.labels.formLabel")}
						onChange={e => setFormLabelValue(e.target.value)}
						value={formLabelValue}
						onBlur={() => updateFormLabel(formLabelValue)}
						status={
							formValidation && formLabelValue === ""
								? "error"
								: undefined
						}
						hint={t(`formDesigner.elements.common.formLabel`)}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<ExpandedLayout
						fullWidth={formLayout?.fullWidth || false}
						updateFormLayoutFullWidth={updateFormLayoutFullWidth}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<MaxWidth
						disabled={!(formLayout?.fullWidth || false)}
						maxWidth={formLayout?.maxWidth || 0}
						updateFormLayoutMaxWidth={updateFormLayoutMaxWidth}
					/>
				</div>
			</div>
		</div>
	);
}
